import { render, staticRenderFns } from "./EditDocumentForm.vue?vue&type=template&id=f804a828"
import script from "./EditDocumentForm.vue?vue&type=script&lang=ts"
export * from "./EditDocumentForm.vue?vue&type=script&lang=ts"
import style0 from "./EditDocumentForm.vue?vue&type=style&index=0&id=f804a828&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports